// animGraphPersist — WHERE a body/face graph edit is persisted, as one rule.
//
// BlueprintGraph's autosave decided this inline: co-editing on and synced →
// the collab document; co-editing off → the localStorage write-through cache;
// co-editing on but NOT synced → nowhere (the canvas is read-only until the doc
// arrives, and a localStorage write there would be the stale-draft failure the
// UX rules name). Deleting a variable from the MY BLUEPRINT rail now edits the
// body and face graphs while THEIR canvases are unmounted, so a second writer
// exists — and a second copy of the rule is how the two would drift. Both call
// this.
//
// `refuse` is a real outcome the caller must honour: a cross-graph delete that
// cannot persist one of its graphs must not run at all, or the event graph
// loses its Set nodes while the face graph keeps reading the variable.

/**
 * @param {{ coeditEnabled: boolean, collabActive: boolean }} flags
 * @returns {'collab'|'local'|'refuse'}
 */
export function resolveAnimGraphPersist({ coeditEnabled, collabActive }) {
  if (coeditEnabled && collabActive) return 'collab'
  if (!coeditEnabled) return 'local'
  return 'refuse'
}

/** The reason shown when a write is refused — plain, because a person reads it. */
export const ANIM_GRAPH_PERSIST_REFUSED =
  'Co-editing is on but this browser is not synced yet, so the body and face graphs cannot be edited from here. Wait for the sync, or turn co-editing off, then try again.'
